import Inputmask from 'inputmask';

Inputmask.extendDefaults({
  showMaskOnHover: false,
  autoUnmask: false
});

Inputmask.extendDefinitions({
  '6': {
    validator: '[6-7]',
    cardinality: 1
  },
  'x': {
    validator: '[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]',
    cardinality: 1,
    casing: 'lower'
  },
  'X': {
    validator: '[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]',
    cardinality: 1,
    casing: 'upper'
  }
});

Inputmask.extendAliases({
  phone_number: {
    mask: '(99 99 99 99 99)|(\\+99 9 99 99 99 99)',
    placeholder: '',
    autoUnmask: true
  },
  sms_code: {
    mask: '9 9 9 9 9',
    placeholder: '',
    autoUnmask: true
  },
  amount: {
    alias: 'numeric',
    digits: 0,
    min: 0,
    max: 1000000000,
    groupSeparator: ' ',
    autoGroup: true,
    autoUnmask: true
  },
  initial_amount: { // overwritten in _simulation_min_overwrite.html.erb
    alias: 'amount',
    // min: window.Anatec.constants.SIMULATION.min_initial_amount,
    max: 10000000
  },
  monthly_amount: { // overwritten in _simulation_min_overwrite.html.erb
    alias: 'amount',
    // min: window.Anatec.constants.SIMULATION.min_monthly_amount,
    max: 100000
  },
  time: {
    alias: 'amount',
    groupSeparator: '',
    max: 100
  },
  date: {
    alias: "datetime",
    inputFormat: "dd/mm/yyyy",
    outputFormat: "dd-mm-yyyy",
    placeholder: "--/--/----",
    clearMaskOnLostFocus: false,
    autoUnmask: false
  },
  RIB: {
    mask: 'AAXX XXXX XXXX XXXX XXXX XXXX XXX',
    autoUnmask: true
  }
});
